
import moment, { Moment } from 'moment';
moment.suppressDeprecationWarnings = true;

const CalendarArrowSvg = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 10.7 35.8"><path d="M.4 1.3c.4-.8 1.5-.8 1.8 0l7 14.4 1.1 2.3-1.1 2.3-6.9 14.2c-.4.8-1.4.8-1.8 0-.1-.3-.1-.6 0-.9l7.6-15.7L.4 2.1c-.1-.2-.1-.6 0-.8z" fill-rule="evenodd" clip-rule="evenodd" fill="#fff"/></svg>';

class InputCalendar {
    constructor(element, options = {}) {
        this.calendarWrapper = element;
        this.inputCalendarE = this.calendarWrapper.querySelector('.k-input-calendar');
        this.calendarIcon = this.calendarWrapper.querySelector('.calendar-icon');
        this.dateSelectedByUser = '';

        let {
            currentDate = moment(),
            format = 'YYYY-MM-DD',
            defaultDate = moment().format(format),
            minDate = moment('1990-01-01', 'YYYY-MM-DD').format(format),
            maxDate = moment().add('20', 'years'),
            monthsOfYear = moment.months(),
            daysOfWeek = moment.weekdaysMin(),
            years = []
        } = options;

        if (this.inputCalendarE.value) {
            if (this.inputCalendarE.value != '') {
                defaultDate = moment(this.inputCalendarE.value, format).format(format);
                if (defaultDate == 'Invalid date') {
                    console.error(`Invalid format date: ${this.inputCalendarE.value} . Please set date with ${format} format.`);
                    console.error(this.inputCalendarE)
                    return false;
                }
            }
        }

        this.calendarOptions = {
            currentDate: currentDate,
            format: format,
            defaultDate: defaultDate,
            minDate: minDate,
            maxDate: maxDate,
            monthsOfYear: monthsOfYear,
            daysOfWeek: daysOfWeek,
            years: years
        }
        this._configureCalendarOptions();
        this._runCalendar();

        this.inputCalendarE.value = this.calendarOptions.defaultDate.toString();
    }

    _configureCalendarOptions() {
        const {
            format,
            defaultDate,
            minDate,
            maxDate
        } = this.calendarOptions;

        if (typeof defaultDate == 'string') {
            this.calendarOptions.defaultDate = moment(defaultDate, format).format(format);
            this.dateSelectedByUser = this.calendarOptions.defaultDate;
        } else if (Object.prototype.toString.call(defaultDate) === '[object Date]') {
            this.calendarOptions.defaultDate = moment(defaultDate).format(format)
        }

        if (typeof minDate == 'string') {
            this.calendarOptions.minDate = moment(minDate, format).format(format)
        } else if (Object.prototype.toString.call(minDate) === '[object Date]') {
            this.calendarOptions.minDate = moment(minDate).format(format)
        }
        
        if (typeof maxDate == 'string') {
            this.calendarOptions.maxDate = moment(maxDate, format).format(format)
        } else if (Object.prototype.toString.call(maxDate) === '[object Date]') {
            this.calendarOptions.maxDate = moment(maxDate).format(format)
        }

        if (moment(this.calendarOptions.defaultDate).isBefore(this.calendarOptions.minDate) ||
            moment(this.calendarOptions.defaultDate).isAfter(this.calendarOptions.maxDate)) {
            this.calendarOptions.defaultDate = this.calendarOptions.minDate;
        }

        if (this.calendarIcon) {
            this.calendarIcon.addEventListener('click', (e) => this.toggleCalendar())
            this.calendarIcon.addEventListener('keydown', (e) =>  {
                if (e.key === 'Enter' || e.key == 'Spacebar' || e.keyCode === 13 || e.keyCode == 32) {
                    this.toggleCalendar();
                }
            })
        }

        this.calendarOptions.currentDate = moment(this.calendarOptions.defaultDate, this.calendarOptions.format);
        this.calendarOptions.currentDate.max(this.calendarOptions.maxDate);
        this.calendarOptions.currentDate.min(this.calendarOptions.minDate);
    }

    _runCalendar() {
        this._generateYears();
        this._createLayout();
        this._createDaysLayout();
        this._loadButtonsEvent();
        this._loadToggleCalendarEvents();
    }

    _generateDays(date = this.calendarOptions.currentDate) {
        let dateStart = moment(date).startOf('month'),
            dateEnd = moment(date).endOf('month'),
            cells = [];
        
        // Encontrar la primer fecha que se va a mostrar en el calendario
        while (dateStart.day() !== 0) {
            dateStart.subtract(1, 'days');
        }

        // Encontrar la última fecha que se va a mostrar en el calendario
        while (dateEnd.day() !== 6) {
            dateEnd.add(1, 'days');
        }
        
        // Genera las fechas del grid
        do {       
            cells.push({
                date: moment(dateStart),
                isCurrentDay: dateStart.date() === this.calendarOptions.currentDate.date() && dateStart.month() === date.month(),
                isInCurrentMonth: dateStart.month() === date.month()
            });
            dateStart.add(1, 'days');
        } while (dateStart.isSameOrBefore(dateEnd));

        
        return cells;
    }

    _generateYears() {
        let years = [],
            more_y = moment(),
            less_y = moment();
        
        let range_years_number = Math.abs(moment(this.calendarOptions.minDate, this.calendarOptions.format).diff(moment(this.calendarOptions.maxDate, this.calendarOptions.format), 'years'));
        
        while (moment(this.calendarOptions.minDate, this.calendarOptions.format).add(range_years_number, 'y').diff(more_y, 'years') >= 0) {
            let format_year = more_y.format('YYYY');
            if (years.indexOf(format_year) == -1) {
                years.push(format_year)
            }
            more_y.add(1, 'year')
        }

        while (moment(this.calendarOptions.maxDate, this.calendarOptions.format).subtract(range_years_number, 'y').diff(less_y, 'years') <= 0) {
            let format_year = less_y.format('YYYY');
            if (years.indexOf(format_year) == -1) {
                years.unshift(format_year)
            }
            less_y.subtract(1, 'year')
        }

        this.calendarOptions.years = years;
    }

    _createDaysLayout(date = this.calendarOptions.currentDate) {
        let days = this._generateDays(date),
            calendar_days_layout = '',
            counter  = 1,
            thisInstance = this;

        days.map((day) => {
            let date = day.date.format(thisInstance.calendarOptions.format),
                isCurrentMonth = thisInstance.calendarOptions.currentDate.month() == moment().month(),
                isValid = moment(date, this.calendarOptions.format).isSameOrAfter(moment(thisInstance.calendarOptions.minDate, this.calendarOptions.format)) ? true : false;
            
            if (thisInstance.dateSelectedByUser != '') {
                isCurrentMonth = moment(thisInstance.dateSelectedByUser, thisInstance.calendarOptions.format).format(thisInstance.calendarOptions.format) == day.date.format(thisInstance.calendarOptions.format);
                let xx =day.date.format(thisInstance.calendarOptions.format);
                let aa =  moment(thisInstance.dateSelectedByUser, thisInstance.calendarOptions.format).format(thisInstance.calendarOptions.format);
            }
   

            calendar_days_layout += counter == 1 ? '<tr class="calendar-row">' : '';
            calendar_days_layout += `
                <td>
                    <button 
                        type="button" 
                        id="kc_input_date_${date}"
                        button-date="${date}"
                        ${!isValid ? 'disabled' : ''}
                        class="kukun-input-calendar-btn
                        ${!day.isInCurrentMonth || !isValid ? 'calendar-btn-disabled' : ''}
                        ${day.isCurrentDay && isCurrentMonth && isValid ? 'btn-calendar-selected' : ''}">
                        ${day.date.date()}
                    </button>
                    <div class="pointers"></pointers>
                </td>
            `;
            counter++;
            if (counter == 8) {
                calendar_days_layout += '</tr>';
                counter = 1;
            }
        })

        this.calendarDaysWrapper.innerHTML = calendar_days_layout;
    }
    
    _createLayout() {
        let caledar_months_layout = '',
            calendar_years_layout = '',
            calendar_week_layout = '',
            thisInstance = this;

        this.calendarOptions.monthsOfYear.map((month) => {
            caledar_months_layout += `
                <li>
                    <button type="button" 
                        class="
                            kukun-input-calendar-month-btn
                            ${month == thisInstance.calendarOptions.currentDate.format('MMMM') ? ' button-list-selected' : ''}
                        " 
                        button-month="${month}">
                        ${month.substr(0,3)}
                    </button>
                </li>`;
        })

        this.calendarOptions.years.map((year) => {
            calendar_years_layout += `
                <li>
                    <button type="button" 
                        class="
                            kukun-input-calendar-year-btn
                            ${year == this.calendarOptions.currentDate.year().toString() ? ' button-list-selected' : ''}
                        " 
                        button-year="${year}">
                        ${year}
                    </button>
                </li>`;
        })

        this.calendarOptions.daysOfWeek.map((day) => {
            calendar_week_layout += `<th>${day}</th>`;
        })

        let basic_layout = `
        <div class="k-calendar-wrapper">
            <div class="month-year">
                <div class="controls month-wrapper">
                    <ul class="months-list">
                        ${caledar_months_layout}
                    </ul>
                    <div class="calendar-arrow calendar-arrow-back">
                        ${CalendarArrowSvg}
                    </div>
                    <p class="month-label">${this.calendarOptions.currentDate.format('MMMM').substr(0,3)}</p>
                    <div class="calendar-arrow calendar-arrow-next">
                        ${CalendarArrowSvg}
                    </div>
                </div>
                <div class="year-wrapper">
                    <ul class="years-list">
                        ${calendar_years_layout}
                    </ul>
                    <p class="year-label">${this.calendarOptions.currentDate.year()}</p>
                </div>
            </div>
            <table cellpadding="0" cellspacing="0" role="grid">
                <thead>
                    <tr>
                       ${calendar_week_layout}
                    </tr>
                </thead>
                <tbody class="kukun-input-calendar-days">

                </tbody>
            </table>
        </div>
        `;

        this.calendarWrapper.insertAdjacentHTML('beforeend', basic_layout); 
        this.calendarDaysWrapper = this.calendarWrapper.querySelector('.kukun-input-calendar-days');
        this.calendarContainer = this.calendarWrapper.querySelector('.k-calendar-wrapper');
        const yearWrapper = this.calendarWrapper.querySelector('.year-wrapper');
        const monthWrapper = this.calendarWrapper.querySelector('.month-wrapper');
        this.yearElements = {
            yearWrapper: yearWrapper,
            yearList: yearWrapper.querySelector('.years-list'),
            yearLabel: yearWrapper.querySelector('.year-label')
        }
        this.monthElemets = {
            monthWrapper: monthWrapper,
            monthList: monthWrapper.querySelector('.months-list'),
            monthLabel: monthWrapper.querySelector('.month-label'),
            arrowBack: monthWrapper.querySelector('.calendar-arrow-back'),
            arrowNext: monthWrapper.querySelector('.calendar-arrow-next'),
        }
    }

    _loadButtonsEvent(option = 'all') {
        let _this = this;
        this.calendarButtons = this.calendarDaysWrapper.querySelectorAll('.kukun-input-calendar-btn');
        this.yearButtons = this.calendarWrapper.querySelectorAll('.kukun-input-calendar-year-btn');
        this.monthButtons = this.calendarWrapper.querySelectorAll('.kukun-input-calendar-month-btn');

        if (option == 'days') {
            days();
        } else {
            days();
            months();
            arrows();
            years();
        }

        function days() {
            // Days buttons 
            if (_this.calendarButtons.length > 0) {
                for (let i = 0; i < _this.calendarButtons.length; i++) {
                    const button = _this.calendarButtons[i];
                    button.addEventListener('click', () => { _this.changeActiveDay(button); _this.calendarWrapper.classList.remove('k-show-input-calendar') })
                }
            }
        }
        function months() {
            // Months list buttons 
            if (_this.monthButtons.length > 0) {
                for (let i = 0; i < _this.monthButtons.length; i++) {
                    const button = _this.monthButtons[i];
                    button.addEventListener('click', () => _this.changeActiveMonth(button))
                }
            }
        }
        function arrows() {
            _this.monthElemets.arrowBack.addEventListener('click', () => _this.changeActiveMonth(null, 'back'))
            _this.monthElemets.arrowNext.addEventListener('click', () => _this.changeActiveMonth(null, 'next'))
        }
        function years() {
            // Year list buttons 
            if (_this.yearButtons.length > 0) {
                for (let i = 0; i < _this.yearButtons.length; i++) {
                    const button = _this.yearButtons[i];
                    button.addEventListener('click', () => _this.changeActiveYear(button))
                }
            }
        }
    }

    _loadToggleCalendarEvents() {
        this.inputCalendarE.addEventListener('click', () => this.toggleCalendar())
        this.inputCalendarE.addEventListener('keydown', (e) =>  {
            if (e.key === 'Enter' || e.key == 'Spacebar' || e.keyCode === 13 || e.keyCode == 32) {
                this.toggleCalendar();
            }
        })
        window.addEventListener('click', (e) => {
            if (!this.calendarWrapper.contains(e.target)) {
                this.calendarWrapper.classList.remove('k-show-input-calendar');
            } 
            if (!this.monthElemets.monthWrapper.contains(e.target)) {
                this.monthElemets.monthList.classList.remove('months-list-show');
            }
            if (!this.yearElements.yearWrapper.contains(e.target)) {
                this.yearElements.yearList.classList.remove('year-list-show');
            }
        })
        // Month 
        this.monthElemets.monthLabel.addEventListener('click', () => {
            this.monthElemets.monthList.classList.add('months-list-show');
        })
        // Year 
        this.yearElements.yearLabel.addEventListener('click', () => {
            this.yearElements.yearList.classList.add('year-list-show');
        })

        // this.calendarWrapper.add
        window.addEventListener('resize', () => {
            if (this.calendarContainer.clientWidth > 410) {
                this.calendarContainer.classList.add('desktop-kukun-input-calendar');
            } else {
                this.calendarContainer.classList.remove('desktop-kukun-input-calendar');
            }
        })
    }

    changeActiveDay(selected_button) {
        for (let i = 0; i < this.calendarButtons.length; i++) {
            const button = this.calendarButtons[i];
            if (button.classList.contains('btn-calendar-selected')) {
                button.classList.remove('btn-calendar-selected');
            }
        }
        selected_button.classList.add('btn-calendar-selected');
        this.inputCalendarE.value = selected_button.getAttribute('button-date');
        this.calendarOptions.defaultDate = selected_button.getAttribute('button-date');
        this.dateSelectedByUser = selected_button.getAttribute('button-date');
        this.calendarOptions.currentDate = moment(this.calendarOptions.defaultDate, this.calendarOptions.format);
    }

    changeActiveMonth(selected_button, option) {
        let button_month = ''; 
        for (let i = 0; i < this.monthButtons.length; i++) {
            const button = this.monthButtons[i];
            if (button.classList.contains('button-list-selected')) {
                button.classList.remove('button-list-selected');
            }
        }

        if (!option) {
            button_month = selected_button.getAttribute('button-month');
            selected_button.classList.add('button-list-selected');
            this.monthElemets.monthList.classList.remove('months-list-show');
        } else {
            if (option == 'next') {
                button_month = this.calendarOptions.currentDate.add(1, 'month').format('MMMM');
            } else {
                button_month = this.calendarOptions.currentDate.subtract(1, 'month').format('MMMM');
            }

            let selected_button = this.monthElemets.monthWrapper.querySelector(`button[button-month="${button_month}"]`);
            if (selected_button) {
                selected_button.classList.add('button-list-selected');
            }
        }
        
        let button_year = this.yearElements.yearList.querySelector(`button[button-year="${this.calendarOptions.currentDate.year()}"]`);

        if (button_year) {
            this.monthElemets.monthLabel.innerText = button_month.substr(0,3);
            this.calendarOptions.currentDate.month(button_month);
            this._createDaysLayout(this.calendarOptions.currentDate.month(button_month).year(this.calendarOptions.currentDate.year()));
            this._loadButtonsEvent('days');
            this.changeActiveYear(button_year);   
        } else {
            if (option == 'next') {
                this.calendarOptions.currentDate.subtract(1, 'month').format('MMMM');
            } else {
                this.calendarOptions.currentDate.add(1, 'month').format('MMMM');
            }
        }
    }

    changeActiveYear(selected_button) {
        let button_year = selected_button.getAttribute('button-year');
        for (let i = 0; i < this.yearButtons.length; i++) {
            const button = this.yearButtons[i];
            if (button.classList.contains('button-list-selected')) {
                button.classList.remove('button-list-selected');
            }
        }
        selected_button.classList.add('button-list-selected');
        this.yearElements.yearLabel.innerText = button_year;
        this.yearElements.yearList.classList.remove('year-list-show');
        this.calendarOptions.currentDate.year(button_year);
        this._createDaysLayout(this.calendarOptions.currentDate.month(this.calendarOptions.currentDate.month()).year(button_year)); 
        this._loadButtonsEvent('days');
    }

    toggleCalendar(option) {
        if (option) {
            if (option == 'open') {
                this.calendarWrapper.classList.add('k-show-input-calendar')
            } else {
                this.calendarWrapper.classList.remove('k-show-input-calendar');
            }
        } else {
            if (this.calendarWrapper.classList.contains('k-show-input-calendar')) {
                this.calendarWrapper.classList.remove('k-show-input-calendar')
            } else {
                this.calendarWrapper.classList.add('k-show-input-calendar');
            }  
        }

        if (this.calendarContainer.clientWidth > 410) {
            this.calendarContainer.classList.add('desktop-kukun-input-calendar');
        } else {
            this.calendarContainer.classList.remove('desktop-kukun-input-calendar');
        }
    }
}


let kukunCalendarInstances = [];

const init = (calendarWrappers, calendarParameters) => {
    if (calendarWrappers) {
        if (typeof calendarWrappers.length == 'undefined') {
            const htmlElement = calendarWrappers;
            const parameters = calendarParameters;
            kukunCalendarInstances = new InputCalendar(htmlElement, parameters);
        } else {
            for (let i = 0; i < calendarWrappers.length; i++) {
                const htmlElement = calendarWrappers[i];
                const parameters = calendarParameters;
                let modalInstance = new InputCalendar(htmlElement, parameters);
                kukunCalendarInstances.push(modalInstance);
            }
        }
    }

    return kukunCalendarInstances;
}


export {
    init
};

